import React, { useState, useCallback, useRef } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import moment from 'moment';
import runtimeConfig from '../../../../config/runtimeConfig';
import DataComponentFinanceBlock from '../../../DataComponent/DataComponentFinanceBlock';
import localStorage from '../../../../helpers/localStorage';

const columnTableData = {
    header: {},
    body: {}
};
const nameLocalStorage = 'payoutPage';

export const PayoutPageContainer = ({
    payouts,
    totalPages,
    headerNames,
    loading,
    selectOptions,
    getPayouts,
    t
}) => {
    const lastSignatureRef = useRef(null);
    const staticNameTable = (t && t.dataTable) || {};

    const onDataTableAction = useCallback((state) => {
        const normalized = {
            ...state,
            page: state.page || 1
        };
        const signature = JSON.stringify(normalized);
        if (signature === lastSignatureRef.current) {
            return;
        }
        lastSignatureRef.current = signature;
        getPayouts(normalized);
    }, [getPayouts]);

    localStorage.set(nameLocalStorage, document.location.search);

    return (
        <DataComponentFinanceBlock
            onAction={onDataTableAction}
            totalPages={totalPages}
            headerNames={headerNames}
            data={payouts}
            loading={loading}
            isQuery={true}
            columnData={columnTableData}
            className="simple-table payout-table"
            gray={true}
            fields={[
                {
                    name: 'datepicker',
                    key: 'create',
                    label: staticNameTable.headers?.createdAt,
                    dropdownLabel: staticNameTable.filter,
                    disabled: true,
                    withTimezone: true,
                    value: {
                        startDate: moment().subtract(runtimeConfig.defaultDatepickerMonthPayoutPeriod, 'month')
                    }
                },
                {
                    name: 'multiselect',
                    key: 'statuses',
                    data: selectOptions,
                    label: staticNameTable.headers?.status,
                    dropdownLabel: staticNameTable.filter,
                    placeholder: staticNameTable.tips?.byStatus
                }
            ]}
        />
    );
};

PayoutPageContainer.propTypes = {
    payouts: PropTypes.array,
    totalPages: PropTypes.number,
    headerNames: PropTypes.array,
    loading: PropTypes.bool,
    selectOptions: PropTypes.array,
    getPayouts: PropTypes.func,
    t: PropTypes.object
};

PayoutPageContainer.defaultProps = {
    payouts: [],
    totalPages: 0,
    headerNames: [],
    loading: false,
    selectOptions: [],
    getPayouts: () => {}
};

export default withTranslation(PayoutPageContainer);
